import { useState } from 'react';
import { cbseResult } from '../../services/ResultService'; // Adjust the import path as necessary
import { FaFileUpload } from 'react-icons/fa';
import Select from '../../components/Select/Select';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import CBSEResultDashboard from './CBSEResultDashboard';
import Loader from '../../components/Loader/Loader'; // Assuming you have a Loader component

const CBSEResult = () => {
  const [result_file, setResultFile] = useState(null);
  const [program_name, setProgramName] = useState(0); // Default to Class 10
  const [data, setData] = useState({}); // State to hold the result data
  const [excel_download_url, setExcelDownloadUrl] = useState(''); // URL for downloading the Excel file
  const [pdf_download_url, setPdfDownloadUrl] = useState(''); // URL for downloading the PDF file
  const [loader, setLoader] = useState(false); // Loader state to show loading spinner
  // This component is currently empty, but you can add your logic here.
  const fileChangeHandler = async (event) => {
    if (event.target.name === "program_name") {
      setProgramName(event.target.value);
    }
    else {
      let result_file = event.target.files[0];
      setResultFile(result_file);
    }
  }

  const submitFileHandler = async (event) => {
    event.preventDefault();

    try {
      setLoader(true); // Assuming you have a loader state to show loading spinner
      const formData = new FormData();
      formData.append('result_file', result_file);
      formData.append('program_name', program_name);
      const response = await cbseResult(formData);

      if (response.status === 200) {
        setExcelDownloadUrl(response.data.data.excel_download_url); // Set the Excel download URL
        setPdfDownloadUrl(response.data.data.pdf_download_url); // Set the PDF download URL
        setData(response.data.data.data); // Assuming the response contains the data you want to display
      } else {
        console.error("Failed to upload file:", response);
      }
    }
    catch (error) {
      console.error("Error uploading file:", error);
    }
    finally {
      setLoader(false); // Hide the loader after the operation
    }
  }

  return (
    <div className="card">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <div className="main-title-page page-title d-flex align-items-center">
            <div className="mx-2">
              <FaFileUpload />
            </div>
            <span>Cbse Result</span>
          </div>
          <div className="page-title-right">
            <Button
              className="btn btn-success mx-2"
              onClick={() => window.open(excel_download_url, '_blank')}
            >
              Excel Download
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => window.open(pdf_download_url, '_blank')}
            >
              PDF Download
            </Button>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <Select
              name="program_name"
              id="program_name"
              placeholder="Select Class"
              value={program_name}
              onChangeHandler={fileChangeHandler}
              options={[{ id: '10', name: 'Class 10' }, { id: '12', name: 'Class 12' }]} // Example options
            />
          </div>
          <div className="col-md-4">
            <Input type="file"
              name="result_file"
              id="result_file"
              onChange={fileChangeHandler}
              placeholder="Enter your query here" />
          </div>
          <div className="col-md-2">
            <Button onClick={submitFileHandler}>Upload</Button>
          </div>
        </div>
        {loader ?
          <Loader /> :
          <div className="row mt-3">
            <div className="col-md-12">
              <CBSEResultDashboard data={data} program_name={program_name} />
            </div>
          </div>}
      </div>
    </div>
  );
};

export default CBSEResult;
